import React from 'react';

type Props = {
  currentCase: string;
  activeCase: string;
  rotated?: boolean;
};

export const TableSortChevron: React.FC<Props> = ({
  activeCase,
  currentCase,
  rotated,
}) => {
  const conditionalClassName = `${
    activeCase === currentCase ? '' : 'low-opacity '
  }${rotated ? 'rotated ' : ''}table-sort-chevron`;

  return (
    <div className={conditionalClassName}>
      <svg
        width="8"
        height="5"
        viewBox="0 0 8 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.788787 4.03091C0.951505 4.2117 1.21532 4.2117 1.37804 4.03091L4.00008 1.11753L6.62212 4.03091C6.78484 4.2117 7.04866 4.2117 7.21138 4.03091C7.37409 3.85011 7.37409 3.55697 7.21138 3.37618L4.29471 0.135435C4.13199 -0.0453634 3.86817 -0.0453634 3.70545 0.135435L0.788787 3.37618C0.626068 3.55697 0.626068 3.85011 0.788787 4.03091Z"
          fill="#4D4558"
        />
      </svg>
    </div>
  );
};
